import { createAction } from 'redux-actions';
import { FILE_UPLOAD_STARTED } from '../constants/actionTypes';
export const fileUploadStarted = createAction(FILE_UPLOAD_STARTED, ({
  fileUpload
}) => ({
  fileUpload
}));